import { RootStore } from 'store/rootStore';
import { action, makeObservable, observable } from 'mobx';
import { MaintenanceFile } from 'types/csvService';
import { downloadByUrl } from '@insurancemenu/imenu-components-lib/dist/helpers/downloadByUrl';
import { COMMON_URLS } from '@insurancemenu/imenu-components-lib/dist/utils/urls';

export class BookOfBusinessStore {
  rootStore: RootStore;
  loading = false;
  maintenanceFiles: MaintenanceFile[] = [];

  public setLoading(status: boolean): void {
    this.loading = status;
  }

  public async getMaintenanceFileIdsByDate(dateFrom: string, dateTo: string, fullView = false): Promise<void> {
    this.setLoading(true);
    const res = await this.rootStore.csvStore.getMaintenanceFileIdsByDate(dateFrom, dateTo, fullView);
    this.maintenanceFiles = res;
    this.setLoading(false);
  }

  // eslint-disable-next-line class-methods-use-this
  public downloadFile(id: string): void {
    const downloadLink = `https://${COMMON_URLS.api}/csvBinary/Prod/download/${id}`;
    downloadByUrl(downloadLink);
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      loading: observable,
      maintenanceFiles: observable,
      setLoading: action.bound,
      getMaintenanceFileIdsByDate: action.bound,
      downloadFile: action.bound,
    });
  }
}
